import { Capacitor } from '@capacitor/core';

export type SubscriptionState = 'OPTED_IN' | 'SUBSCRIBED' | 'UNSUBSCRIBED';

export interface ContentCard {
    id: string;
    title?: string;
    description?: string;
    imageUrl?: string;
    url?: string;
    created: number;
    expiresAt?: number;
    pinned: boolean;
    dismissed: boolean;
    clicked: boolean;
    viewed: boolean;
    logClick(): void;
    logImpression(): void;
    logDismissal(): void;
}

export interface BrazeClient {
    start(apiKey: string, baseUrl: string, opts?: { serviceWorker?: string; logging?: boolean }): Promise<void>;
    openSession(): void;
    changeUser(externalId: string): void;
    setEmail(email: string): void;
    addAlias(alias: string, label: string): void;
    setSubscriptions(s: { push?: SubscriptionState; email?: SubscriptionState }): void;
    setAttributes(attrs: Record<string, unknown>): void;
    logEvent(name: string, props?: Record<string, unknown>): void;
    requestImmediateDataFlush(): Promise<boolean>;
    wipeData(): void;
    disableSDK(disabled: boolean): void;
    requestContentCardsRefresh(): Promise<void>;
    getContentCards(): ContentCard[];
}

export async function createBraze(): Promise<BrazeClient> {
    const isNative = Capacitor.isNativePlatform();
    if (isNative) {
        const { NativeBrazeClient } = await import('./native');
        return new NativeBrazeClient();
    } else {
        const { WebBrazeClient } = await import('./web');
        return new WebBrazeClient();
    }
}
